import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_PM_UPCOMING_EVENTS_API } from "./apiRoutes";

interface Props {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getUpcomingEvents = async (projectId: string) => {
  return await axiosAuth.get(`${DASHBOARD_PM_UPCOMING_EVENTS_API(projectId)}`);
};

const useGetPmUpcomingEvents = ({ projectId, queryParams }: Props): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-upcoming-events", projectId],
    queryFn: () => getUpcomingEvents(projectId),
    select: (data: any) => data.data.data,
    refetchOnWindowFocus: false,
    enabled: !!projectId,
    ...queryParams,
  });
};

export default useGetPmUpcomingEvents;
